import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType, Dataset } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi, ApiService } from 'src/app/handlers/apiHandler.service';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-global-supplier-store-map-config',
  standalone: false,
  templateUrl: './global-supplier-store-map-config.component.html'
})
export class GlobalSupplierStoreMapConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor(private apiHandler: ApiService) { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier-store-map',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'globalSupplierStoreMapId', header: 'Supplier Store Map ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true  },
        { field: 'globalSupplierAbnId', header: 'Global Supplier ABN', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier-abn/lookup' },
        { field: 'storeId', header: 'Store', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup', addFormValidators: [Validators.required] },
        { field: 'storeSupplierId', header: 'Store Supplier', type: ColumnType.MultiSelectComplex, setUrl: 'store-supplier/lookup-temp', addedComplexFields: ['storeId'], addFormValidators: [Validators.required] },
        { field: 'freightPluExGst', header: 'Freight PLU Ex GST', type: ColumnType.String },
        { field: 'freightPluIncGst', header: 'Freight PLU Inc GST', type: ColumnType.String },
        { field: 'documentNumberSupplierPrefix', header: 'Document Number Supplier Prefix', type: ColumnType.String },
        { field: 'productMatchOnOrderCode', header: 'Product Match on Order Code', type: ColumnType.Boolean },
        { field: 'cleanCreditLineItems', header: 'Clean Credit Line Items', type: ColumnType.Boolean },
        { field: 'forceLineItems', header: 'Force Line Items', type: ColumnType.Boolean },
        { field: 'enableHistoricalMatching', header: 'Enable Historical Matching', type: ColumnType.Boolean },
        { field: 'enableHistoricalVarianceMatching', header: 'Enable Historical Variance Matching', type: ColumnType.Boolean }
      ],
      addFormConfig: {
        header: 'Add Global Supplier Store Map'
      },
      isConfigurable: true
    };
  }

  displayAddModel = false;
  showAddModel() {
    this.displayAddModel = true;
    console.log('Hello');
  }
}




